import { atom } from 'recoil';

const kioskOriginLocationIdState = atom({
    key: 'kioskOriginLocationId',
    default: undefined
});

export default kioskOriginLocationIdState;
